import { CalendarBookedLg, Location } from '@prenuvo/halo-icon';
import { Container, Icon, Typography } from '@prenuvo/halo-web';
import { formatInTimeZone } from 'date-fns-tz';
import { PrenuvoLogo } from '@/components';
import { useConfirmationBookingInfo } from '@/hooks';

export const ConfirmationBookingInfo = () => {
  const { firstname, lastname, email, selectedSku, location, utcStart } =
    useConfirmationBookingInfo();

  return (
    <div className="mb-3 mt-6 p-px">
      <Container
        variant={'inset'}
        className="grid grid-cols-1 items-center gap-4 rounded-2xl border border-green-500 p-4 md:grid-cols-2"
      >
        <div className="md:col-span-2">
          <Typography variant="h4" as="h4" className="mb-1">
            {firstname} {lastname}
          </Typography>
          <Typography variant="button-sm" as="p" className="break-words text-neutral-700">
            {email}
          </Typography>
        </div>
        <div className="flex gap-4 md:col-span-2">
          <PrenuvoLogo />
          <Typography variant="paragraph-lg-bold" as="p">
            {selectedSku?.shortName}
          </Typography>
        </div>
        <div className="flex items-center justify-start gap-4">
          <div>
            <Icon
              className="fill-neutral-950"
              size="md"
              source={CalendarBookedLg}
              role="img"
              aria-label="calendar icon"
            />
          </div>
          <div>
            <Typography variant="paragraph-lg" as="p" className="mb-1">
              {utcStart && location?.timezone
                ? `${formatInTimeZone(new Date(utcStart * 1000), location.timezone, 'hh:mm aa')} - ${location?.displayTimezone}`
                : null}
            </Typography>
            <Typography variant="button-sm" as="p" className="text-neutral-700">
              {utcStart && location?.timezone
                ? formatInTimeZone(
                    new Date(utcStart * 1000),
                    location.timezone,
                    'eeee, MMM dd, yyyy',
                  )
                : null}
            </Typography>
          </div>
        </div>
        <div className="flex items-center justify-start gap-4">
          <div>
            <Icon
              className="fill-current"
              size="md"
              source={Location}
              role="img"
              aria-label="map icon"
            />
          </div>
          <div>
            <Typography variant="paragraph-lg" as="p" className="mb-1">
              {location?.name}
            </Typography>
            <Typography variant="button-sm" as="p" className="text-neutral-700">
              {`${location?.address?.address1}, ${location?.address?.city}, ${location?.address?.state} ${location?.address?.postalCode}`}
            </Typography>
          </div>
        </div>
      </Container>
    </div>
  );
};
